import EnumSet from 'Services/enumSet'

interface IBrazilStates extends EnumSet {
  acre: number
  alagoas: number
  amazonas: number
  amapa: number
  bahia: number
  ceara: number
  distritofederal: number
  espiritosanto: number
  goias: number
  maranhao: number
  minasgerais: number
  matogrossodosul: number
  matogrosso: number
  para: number
  paraiba: number
  pernambuco: number
  piaui: number
  parana: number
  riodejaneiro: number
  riograndedonorte: number
  rondonia: number
  roraima: number
  riograndedosul: number
  santacatarina: number
  saopaulo: number
  sergipe: number
  tocantins: number
}

const brazilStates = new EnumSet({
  acre: { value: 1, description: 'AC', },
  alagoas: { value: 2, description: 'AL', },
  amazonas: { value: 3, description: 'AM', },
  amapa: { value: 4, description: 'AP', },
  bahia: { value: 5, description: 'BA', },
  ceara: { value: 6, description: 'CE', },
  distritofederal: { value: 7, description: 'DF', },
  espiritosanto: { value: 8, description: 'ES', },
  goias: { value: 9, description: 'GO', },
  maranhao: { value: 10, description: 'MA', },
  minasgerais: { value: 11, description: 'MG', },
  matogrossodosul: { value: 12, description: 'MS', },
  matogrosso: { value: 13, description: 'MT', },
  para: { value: 14, description: 'PA', },
  paraiba: { value: 15, description: 'PB', },
  pernambuco: { value: 16, description: 'PE', },
  piaui: { value: 17, description: 'PI', },
  parana: { value: 18, description: 'PR', },
  riodejaneiro: { value: 19, description: 'RJ', },
  riograndedonorte: { value: 20, description: 'RN', },
  rondonia: { value: 21, description: 'RO', },
  roraima: { value: 22, description: 'RR', },
  riograndedosul: { value: 23, description: 'RS', },
  santacatarina: { value: 24, description: 'SC', },
  saopaulo: { value: 25, description: 'SP', },
  sergipe: { value: 26, description: 'SE', },
  tocantins: { value: 27, description: 'TO', },
}) as IBrazilStates

export const getStateName = (value: number): string => ({
  1: 'Acre',
  2: 'Alagoas',
  3: 'Amazonas',
  4: 'Amapá',
  5: 'Bahia',
  6: 'Ceará',
  7: 'Distrito Federal',
  8: 'Espirito Santo',
  9: 'Goias',
  10: 'Maranhão',
  11: 'Minas Gerais',
  12: 'Mato Grosso do Sul',
  13: 'Mato Grosso',
  14: 'Pará',
  15: 'Paraíba',
  16: 'Pernambuco',
  17: 'Piauí',
  18: 'Paraná',
  19: 'Rio de Janeiro',
  20: 'Rio Grande do Norte',
  21: 'Rondônia',
  22: 'Roraima',
  23: 'Rio Grande do Sul',
  24: 'Santa Catarina',
  25: 'São Paulo',
  26: 'Sergipe',
  27: 'Tocantins',
}[value])

export default brazilStates